<template lang="pug">
    .row-teaser
        .columns
            .column.image-wrap.is-3
                .image
                    router-link(
                        :to="route"
                        @mouseover.native="hover"
                        @mouseleave.native="blur"
                    )
                        figure
                            img(v-if="showImage" v-lazy="image" :title="title" )
            .column
                .text
                    .bait(v-if="title")
                        | {{ title }}
                    .headline(v-if="text" v-line-clamp:24="6")
                        p.content(v-html="striptags(text)")
                    .link
                        router-link(:to="route") weitere Informationen ...
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'
import truncate from 'truncate-html'
import striptags from 'striptags'
import { mapGetters } from 'vuex'

export default {
    name: 'TeaserStellenanzeigen',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
        }
    },
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        origin: {
            type: String|Number,
            required: true,
        },
        display: {
            type: String,
            default: 'row',
        },
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {
            let image
            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?$preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?preview=blur`,
            }
        },
        route() {
            let categoryKey = get(this.teaser, 'category.key')
            const key = this.teaser.key

            // let categoryPath
            switch (categoryKey) {
                case 'news':
                    // categoryPath = `/aktuelles/${key}`
                    categoryKey = 'aktuelles';
                    break;

                case 'stellenanzeigen':
                    // categoryPath = `/presse/${key}`
                    categoryKey = 'stellenanzeigen';
                    break;
            }

            let route = {
                name: categoryKey,
                params: { key },
                query: {
                    origin: this.origin
                }
            }

            let src
            const referencedPost = get(this.teaser, 'category.cms.id') !== this.cms.id
            if (referencedPost) src = get(this.teaser, 'category.cms.id')
            else src = get(this.reference, 'menuItem.menu.cms.id')
            if (src) route.params.src = src

            return route
        },
        topic() {
            return get(this.teaser, 'category.name')
        },
        title() {
            return get(this.teaser, 'title')
        },
        referencedCmsName() {
            let name
            const referencedCmsID = get(this.teaser, 'category.cms.id')
            if (referencedCmsID && referencedCmsID !== this.cms.id) {
                name = get(this.teaser, 'category.cms.name')
            }
            return name
        },
        text() {
            let text, content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }

            if (! (content && content.text) && this.postSection) {
                content = this.postSection.contents.find(content => content.key === 'content')
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return content.text
        },
        sections() {
            return this.teaser.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
        ...mapGetters( {
            reference: 'currentPage/reference',
            cms: 'CMS',
        })
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'

    .row-teaser
        text-align: initial
        padding: 15px
        color: #000
        border: 1px solid #80bb3d

        .image-wrap
            display: flex
            justify-content: center
            align-items: center
            .image
                max-width: 200px
                text-align: center
                img
                    max-height: 100px


        .headline .content::v-deep
            strong
                font-size: 26px

        h3
            line-height: 1.3
            margin-bottom: 10px
            color: #80bb3d
        p.topic
            font-size: .85rem
            margin-bottom: 10px
        .bait
            word-break: normal !important
            br + br
                display: none
        .link a
            font-weight: bold
            color: #80bb3d
            text-decoration: underline
            &:hover
                color: #000
 
                
</style>
